var map = {
	"./arrow-down-blue.svg": 24382,
	"./arrow-down-grey.svg": 23560,
	"./arrow-right-white.png": 69845,
	"./arrow-right.svg": 15327,
	"./auroraplus.svg": 87991,
	"./avalanche_token_round.png": 57144,
	"./big_unicorn.png": 10776,
	"./blue-loader.svg": 80539,
	"./brave.png": 97714,
	"./circle-grey.svg": 46146,
	"./circle.svg": 91858,
	"./coinbaseWalletIcon.svg": 52654,
	"./dragonfly.svg": 45470,
	"./dropdown-blue.svg": 85577,
	"./dropdown.svg": 82143,
	"./dropup-blue.svg": 64648,
	"./electric.svg": 736,
	"./ethereal.svg": 80212,
	"./ethereum-logo.png": 78780,
	"./farm.webp": 76799,
	"./fortmaticIcon.png": 53911,
	"./hero.webp": 45946,
	"./jump.svg": 27403,
	"./lemniscap.svg": 36194,
	"./link.svg": 90846,
	"./magnifying-glass.svg": 36199,
	"./menu.svg": 28647,
	"./metamask.png": 58843,
	"./noise.png": 58976,
	"./plus-blue.svg": 79335,
	"./plus-grey.svg": 20155,
	"./portisIcon.png": 51307,
	"./question-mark.svg": 83345,
	"./question.svg": 63036,
	"./spinner.svg": 88894,
	"./swap.webp": 17373,
	"./token-list/lists-dark.png": 62726,
	"./token-list/lists-light.png": 94966,
	"./token-logo.png": 62877,
	"./trustWallet.png": 38398,
	"./walletConnectIcon.svg": 69854,
	"./x.svg": 91275,
	"./xl_uni.png": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;